module.exports = __webpack_public_path__ + "static/media/NIT_Inline_RGB_FullColour.e4285ad7.svg";